module.exports = __webpack_public_path__ + "img/mark.b2c98ba3.png";